import Cookies from 'js-cookie';
import { formValidation } from '../global/_formValidation';
import { getUrlVar } from '../global/_getUrlVars';
import { slickRecs } from '../productRecs/_productRecs';
import { slickRecsATB } from '../productRecs/_productRecs';
import { addToWLPersonalizationTracking } from '../global/_personalization';
import { registryListResponse, registryListJSONResponse } from './_registryListResponse.js';
import { scrollToATWLAlert } from './_scrollToATWLAlert';
import { getAttrState } from '../modals_2017/_attrQVfunct.js'

const registryReturnCodeMessages = () => {
	var returnCode = getUrlVar('returnCode');
	if (returnCode != '' && returnCode != null) {
		var text = '',
			regMessageClassInfo = '';
		switch (returnCode) {
			case '0':
				text = 'Thank you! Your selections have been added to your registry!';
				regMessageClassInfo = 'alert-success';
				break;
			case '1':
				text = 'Your selections include items already requested on your registry. Please check your Management Center to change/update quantities.';
				regMessageClassInfo = 'alert-warning';
				break;
			case '2':
				text = 'We were unable to add all selections to your registry. Please check your Management Center for a complete list of items.';
				regMessageClassInfo = 'alert-danger';
				break;
			case '3':
				text =
					"One or more of the items you just selected cannot be added to your registry. Please visit your Registry Management Center to view available items. Dillard's commitment to offer new trends and fashions means we periodically change our assortment.";
				regMessageClassInfo = 'alert-danger';
				break;
			default:
				break;
		}
		if (text != '' && regMessageClassInfo != '') {
			let alertBox = `<div data-twist="preorder-alert" id="preorder-alert" class="alert ${regMessageClassInfo} alert-dismissible" role="alert">
						                <button data-twist="preorder-alert-closelink" class="alert-dismiss" type="button" data-dismiss="alert" title="Close Message"><i class="fa fa-times"></i></button>${text}</div>`;
			if ($('#registryMessage div').length == 0) $('#registryMessage').prepend(alertBox);
		}
	}
};

const allDevicesColorRegistryButton = () => {
	var userInfoValue = Cookies.get('userInfo');
	if (userInfoValue) {
		var parseUserInfoCookie = $.parseJSON(userInfoValue);
		let df = 'DefaultRegistry';
		if (parseUserInfoCookie[df] != undefined) $('.add-to-registry, .alert-success').addClass('userRegistered');
	}
};

const allDevicesBindEventTypeToRURL = () => {
	var eventTypeSelectFCM = $('.find-create-manage-wrapper select[name="eventType"]');
	if (eventTypeSelectFCM.length > 0) {
		eventTypeSelectFCM.on('change', function () {
			$('#regHomeCreate')
				.find('input[name="rURL"]')
				.attr('value', 'RegistryCreate?langId=-1&catalogId=301&storeId=301&eventType=' + eventTypeSelectFCM.val());
		});
	}
};

const ajaxAddToRegistry = (params, returnHTML) => {
	function myCallback() {
		//Other callback js for ajaxAddToBag
		formValidation();
		$('#addedToWishlist-alert, #addedToWishlist-error-alert, #addedToWishlist-lowqty-alert').fadeOut(3000);
		var slicking = setInterval(function () {
			if ($('#add-to-registry-rec .rec-list li img').length > 0 && $('#add-to-registry-rec .rec-list li').last().find('img').length > 0) {
				slickRecsATB($('#add-to-registry-rec .rec-list li'), $('#add-to-registry-rec .rec-list'));
				clearInterval(slicking);
			}
		}, 500);
	}
	var $form = $(`#${params.formId}`),
		imageForAddToModal = '',
		productTitleForAddToModal = 'asd';
	if ($('.quickview-image').length > 0) {
		if ($('.dynamicModalContainer').hasClass('oss-modal')) fromCYL = true;
		$('body').css('top', '');
		imageForAddToModal = $('.dynamicModalContainer').find('.mainImage').eq(0).attr('src');
		// productTitleForAddToModal = $(".dynamicModalContainer").find(".modal-title").last().text();
	} else if ($('.chanel-bundle').length > 0) {
		imageForAddToModal = $form.find('img').eq(0).attr('src');
		productTitleForAddToModal = `${$form.find('.chanel-title').html()}|${$form.find('.product-title').html()}|${$form.find('.product-subtitle').html()}`;
	} else if ($('.chanel-product').length > 0) {
		imageForAddToModal = $('.mainImage').attr('src');
		productTitleForAddToModal = `${$('.chanel-title').html()}|${$('.product-title').html()}|${$('.product-subtitle').html()}`;
	} else if ($('.chanel-product-item').length > 0) {
		imageForAddToModal = $form.find('img').eq(0).attr('src');
		productTitleForAddToModal = `${$('.chanel-title').eq(0).html()}|${$('.product-title').eq(0).html()}|${$('.product-subtitle').eq(0).html()}`;
	} else if ($('.product-bundle-page').length > 0) {
		imageForAddToModal = $form.parents('.list-item').find('.product-image').attr('src');
		productTitleForAddToModal = $form.parents('.list-item').find('.name').html();
	} else if ($('.product-grouping-display-page').length > 0) {
		if (params.formId == 'OrderItemAdd_0') {
			let bundleImg = !$('.desktopPage').length > 0 ? $('.mainProductImage .slick-active img') : $('.mainImage');
			imageForAddToModal = bundleImg.attr('src');
			productTitleForAddToModal = $('.product-title').html();
		} else {
			imageForAddToModal = $form.parents('.list-item').find('.product-image').attr('src');
			productTitleForAddToModal = $form.parents('.list-item').find('.name').html();
		}
	} else if ($('.product-item-display-page').length > 0) {
		imageForAddToModal = $form.find('.list-item').find('img').attr('src');
		productTitleForAddToModal = $('.product-title').html();
	} else if ($('.product-item-attr-page').length > 0) {
		imageForAddToModal = $form.find('.list-item').find('.product-image').attr('src');
		productTitleForAddToModal = $('.product-title').html();
	} else if ($('.outfit-display-page').length > 0) {
		imageForAddToModal = $form.parents('article').find('figure img').attr('src');
		productTitleForAddToModal = $form.parents('article').find('h1, h2').html();
	}
	var attrsString = '';
	if (params.formId != 'eCardForm' && params.formId != 'PickRegistry') {
		$(`#${params.formId} .form-group`)
			.not('.quantity-container, .quantity-select')
			.each(function () {
				var attrValue = '';
				if ($(this).find('.one-option').length > 0) attrValue = $(this).find('.one-option').html();
				else {
					var thisSelect = $(this).find('select');
					thisSelect.find('option').each(function () {
						if ($(this).attr('value') == thisSelect.val()) attrValue = $(this).data('attrvalue');
					});
				}
				if (attrsString.length != 0) attrsString += '|';
				if (attrValue.length != 0) attrsString += `${$(this).find('label').html()}:${attrValue}`;
			});
		$(`#${params.formId}`).append(`<input type='hidden' name='field2' value='${attrsString}' id='FieldTwoForForm' />`);
		$(`#${params.formId}`).append(`<input type='hidden' name='formId' value='${params.formId}' id='formId' />`);
	}
	formValidation();
	var form = $(`#${params.formId}`);
	if ($(`#${params.formId}`).find('.has-error').length == 0) {
		var form = $('#' + params.formId);
		//Get current selected attrs/values and get that sku/catentryid number
		let curAttrStateSKU = getAttrState();
		let getDivSKUs = JSON.parse(document.getElementById('allSkus').innerText);
		const skuAllAttrVals = Object.values(getDivSKUs).filter(sku=>{
			return sku?.definingAttributes?.every(attribute =>{
				if(curAttrStateSKU[attribute.name]?.selectedValue && curAttrStateSKU[attribute.name]?.selectedValue != attribute.value.value){
					return false;
				}
				return true;
			})
		})		
		document.querySelector('#catEntryIdSKU').value = skuAllAttrVals[0].catentryId;
		const updateFormWithCategoryId = () => {
			let parentToLookForPersonalizationSuper = $('body');
			if ($('.quickview-image').length > 0) {
				parentToLookForPersonalizationSuper = $('.modal-body');
			}
			if (parentToLookForPersonalizationSuper.find('.personalizationsuperforpoints').length > 0 && parentToLookForPersonalizationSuper.find('.personalizationsuperforpoints').eq(0).html().length > 0) {
				document.querySelector('#FieldTwoForForm').value = parentToLookForPersonalizationSuper.find('.personalizationsuperforpoints').eq(0).html().trim()
			}
		}
		updateFormWithCategoryId()
		
		$('#addedToRegistrylist-alert, #addedToRegistrylist-error-alert, #addedToRegistrylist-lowqty-alert').fadeOut(3000);
		if (form.find('input[name=itemRegistryAddedFrom]').length == 0)
			form.append('<input type="hidden" name="itemRegistryAddedFrom" value="add-to-registry"' + params.formId + '" />');
		else form.find('input[name=itemRegistryAddedFrom]').val(params.formId);
		
		$("input[name='URL']").val('ProductDisplay');
		$("input[name='rURL']").val('ProductDisplay');

		//get current state of attrs/values
		let curAttrState = getAttrState();

		//build string with : and |
		const attr_String = Object.values(curAttrState).map(aVal => `${aVal.attrName}:${aVal.selectedValue}`).join('|');	

		form.find('.form-group').not('.quantity-container, .quantity-select')			
		form.append("<input type='hidden' name='field3' value='" + attr_String + "' id='FieldThreeForForm' />");

		//storing form details in session
		sessionStorage.setItem('catentry', params.catentry)
		sessionStorage.setItem('formId', params.formId)
		sessionStorage.setItem('curAttrStateSKU', JSON.stringify(curAttrStateSKU))
		
		var form = $(`#${params.formId}`);
		var addorderItemId = params.formId;
		var addcatEntryId = params.catentry;
			console.log("addcatEntryId",addcatEntryId)
		var URL = '/webapp/wcs/stores/servlet/ItemRegistryAdd';
		addToWLPersonalizationTracking();

		//Protocol must be in the URL for IE9 to allow call to occur
		$.ajax({
			url: URL,
			cache: false,
			type: 'POST',
			data: $(`#${params.formId}`).serialize(),
			success: function (ajaxResponse) {
				const formajax = $(`#${params.formId}`);

				if(ajaxResponse.search('forgot-password') > 0) {
						//user is getting redirected to logon
						var baseURL = '/webapp/wcs/stores/servlet/ItemRegistryAdd';
						var form = $('#' + params.formId);
						var productId = form.find(' :input[name=productId]').val();
						var outfitPage = form.find(' :input[name=outfitPage]').length > 0 ? '&outfitPage=Y' : '';
						if (outfitPage) productId = $('form#OrderItemAdd_0 :input[name=catEntryId]').val();
						var protocol = 'https://';
						var fURL = `${protocol}${window.location.host}${baseURL}`;
						var prefix = 'reg';
						if (Modernizr.sessionstorage) {
							//get current state of attrs/values
							let curAttrState_Session = getAttrState();
							//build string with : and |
							let storageString = Object.values(curAttrState_Session).map(aVal => `${aVal.attrName}:${aVal.selectedValue}`).join('|');
								
							//if user didn't select anything
							if (storageString.length == 0) {
								sessionStorage.setItem(`${prefix}Attempt`, '-');
							} else {
								sessionStorage.setItem(`${prefix}Attempt`, storageString);
								sessionStorage.setItem('attemptId', form.data('catentry'));
							}
							
						}
						form.append("<input type='hidden' name='finalView' value='LogonForm' />");
						form.find(' :input[name=URL]').val(`ProductDisplay?storeId=301&catalogId=301&langId=-1&productId=${productId}${outfitPage}`);
					    form.find(' :input[name=rURL]').val(`ProductDisplay?storeId=301&catalogId=301&langId=-1&productId=${productId}${outfitPage}`);
						form.prop('action', fURL);
						form.submit();
				}
			    
				//html response contains createRegistry
				else if(ajaxResponse.search('createRegistry') > 0){
					//user is getting redirected to createRegistryPage
					let locationURL = `https://${window.location.host}/webapp/wcs/stores/servlet/`;
					var form = $(`#${params.formId}`);
					form.append('<input type="hidden" name="createForm" value="true" />');
					form.find(' :input[name=URL]').val(`ItemRegistryAdd?${form.serialize()}`);
					location.href = `${locationURL}RegistryCreate?${form.serialize()}`;
				}

				//html response contains PickRegistryModal
				else if(ajaxResponse.search('PickRegistryModal') > 0){
					
					$('#dynamicModalContainer').modal({
						backdrop: 'static',
						keyboard: false,
					});
					// $('.modal-backdrop, .modalDynamicRemove').remove();
					returnHTML(ajaxResponse, myCallback);
					$('.modal-title').addClass('pickRegistry');
					$('.modal-body').addClass('pickRegistryBody');
					$('.modal-title').html('Pick a Registry.');
					$('.close').show();
				}

				//html response contains AddToRegistryModal
				else if(ajaxResponse.search('AddToRegistryModal') > 0){
					var manageRegistryURL = $(ajaxResponse).find("a").attr("href");
					const addedMessage = $(
								`<div data-twist="pd-msg-block" id="addedToRegistrylist-alert" class="alert alert-success alert-dismissible new-WLalert" role="alert"><button class="alert-dismiss" type="button" data-dismiss="alert" id="addedToRegistrylist-alert-close-btn"><i  data-twist="pd-msg-close-link" class="fa fa-times"></i></button>This item was added to your registry list. <br><a data-twist="pd-click-here" href="${manageRegistryURL}">Click here</a> to view your registry list</div>`
								);
					$(addedMessage).insertAfter('#add-to-bag');
				}

				//html response contains Error Adding Item to Your Registry
				else if (ajaxResponse.search('Error Adding Item to Your Registry') > 0) {
					const errorMessage = $(
						'<div id="addedToRegistrylist-error-alert" class="alert alert-danger alert-dismissible" role="alert"><button class="alert-dismiss" type="button" data-dismiss="alert" id="addedToRegistrylist-alert-close-btn"><i class="fa fa-times"></i></button>There was an error adding this item to your registry list. Please try again later.</div>'
					).insertAfter('#add-to-bag');
					$(errorMessage).insertAfter('#add-to-bag');
				}
				
				//Cart Page
				else {
					let locationURL = `https://${window.location.host}/webapp/wcs/stores/servlet/`;
					location.href = `${locationURL}OrderItemDisplay?storeId=301&catalogId=301&langId=-1&mvId=${addcatEntryId}`;
				}
				scrollToATWLAlert();
				$('#FieldThreeForForm').remove();
			},
			
			error: function (e) {
				console.log("error function ", e)
				let locationURL = `https://${window.location.host}/webapp/wcs/stores/servlet/`;
				var attrsStringForCookie = '';
				$(`#${params.formId}`)
					.find('select')
					.each(function () {
						if (attrsStringForCookie.length > 0) attrsStringForCookie += '|';
						attrsStringForCookie += `${$(this).attr('id')}:${$(this).val()}`;
					});
				Cookies.set('attemptToAddToReg', `${params.formId};${attrsStringForCookie}`, {
					path: '/',
				});
				var form = $(`#${params.formId}`);
				form.append('<input type="hidden" name="finalView" value="LogonForm" />');
				form.find(' :input[name=URL]').val(`ProductDisplay?${form.serialize()}`);
				form.find(' :input[name=rURL]').val(`ProductDisplay?${form.serialize()}`);
				location.href = `${locationURL}LogonForm?${form.serialize()}`;
			},
		});
	}
};

const ajaxMoveToRegistry = (params, returnHTML) => {
	function myCallback() {
		//Other callback js for ajaxAddToBag
		formValidation();
		$('#addedToWishlist-alert, #addedToWishlist-error-alert, #addedToWishlist-lowqty-alert').fadeOut(3000);
		var slicking = setInterval(function () {
			if ($('#add-to-registry-rec .rec-list li img').length > 0 && $('#add-to-registry-rec .rec-list li').last().find('img').length > 0) {
				slickRecsATB($('#add-to-registry-rec .rec-list li'), $('#add-to-registry-rec .rec-list'));
				clearInterval(slicking);
			}
		}, 500);
	}
	var $form = $(`#${params.formId}`),
		orderItemId = params.orderItemId,
		catEntryId = params.catEntryId,
		calledFrom = params.calledFrom,
		imageForAddToModal = '',
		productTitleForAddToModal = 'asd';

		$(`#${params.formId}`).append(`<input type='hidden' name='orderItemId' value='${orderItemId}' />`);
		$(`#${params.formId}`).append(`<input type='hidden' name='catEntryId' value='${catEntryId}' />`);
		$(`#${params.formId}`).append(`<input type='hidden' name='calledFrom' value='${calledFrom}' />`);
		
	if ($('.quickview-image').length > 0) {
		if ($('.dynamicModalContainer').hasClass('oss-modal')) fromCYL = true;
		$('body').css('top', '');
		imageForAddToModal = $('.dynamicModalContainer').find('.mainImage').eq(0).attr('src');
		// productTitleForAddToModal = $(".dynamicModalContainer").find(".modal-title").last().text();
	} 
	var attrsString = '';
	if (params.formId != 'eCardForm' && params.formId != 'PickRegistry') {
		$(`#${params.formId} .form-group`)
			.not('.quantity-container, .quantity-select')
			.each(function () {
				var attrValue = '';
				if ($(this).find('.one-option').length > 0) attrValue = $(this).find('.one-option').html();
				else {
					var thisSelect = $(this).find('select');
					thisSelect.find('option').each(function () {
						if ($(this).attr('value') == thisSelect.val()) attrValue = $(this).data('attrvalue');
					});
				}
				if (attrsString.length != 0) attrsString += '|';
				if (attrValue.length != 0) attrsString += `${$(this).find('label').html()}:${attrValue}`;
			});
		$(`#${params.formId}`).append(`<input type='hidden' name='field2' value='${attrsString}' id='FieldTwoForForm' />`);
		$(`#${params.formId}`).append(`<input type='hidden' name='formId' value='${params.formId}' id='formId' />`);
	}
	formValidation();
	if ($(`#${params.formId}`).find('.has-error').length == 0) {
		var form = $(`#${params.formId}`);
		var URL = '/webapp/wcs/stores/servlet/ItemRegistryAdd';
		// if ($('.ie9').length > 0) {
		// 	var httpLoggedIn =
		// 		window.location.protocol == 'http:' &&
		// 		Cookies.get('userInfo') != undefined &&
		// 		Cookies.get(`WC_USERACTIVITY_${JSON.parse(Cookies.get('userInfo')).userId}`) != undefined;
		// 	//IE9 wants full URLs with http if you are logged in or persistent, https for guests
		// 	let URLfragment = `://${window.location.host}${URL}`;
		// 	URL = httpLoggedIn ? `http${URLfragment}` : `https${URLfragment}`;
		// }

		addToWLPersonalizationTracking();
		let sesFormId = sessionStorage.getItem('formId')
		let tempFormId = params.formId ?? sesFormId
		let data = $(`#${tempFormId}`).serialize()
		//Protocol must be in the URL for IE9 to allow call to occur
		$.ajax({
			url: URL,
			cache: false,
			type: 'POST',
			data: $(`#${tempFormId}`).serialize(),
			success: function (html) {
				if (html.search('id="createRegistry"') > 0) {
					//user is getting redirected to createRegistryPage
					let locationURL = `https://${window.location.host}/webapp/wcs/stores/servlet/`;
					var form = $(`#${params.formId}`);
					form.append('<input type="hidden" name="createForm" value="true" />');
					form.find(' :input[name=URL]').val(`ItemRegistryAdd?${form.serialize()}`);
					location.href = `${locationURL}RegistryCreate?${form.serialize()}`;
				} else if (html.search('class="forgot-password') > 0) {
					//user is getting redirected to logon
					var attrsStringForCookie = '';
					$(`#${params.formId}`)
						.find('select')
						.each(function () {
							if (attrsStringForCookie.length > 0) attrsStringForCookie += '|';
							attrsStringForCookie += `${$(this).attr('id')}:${$(this).val()}`;
						});
					Cookies.set('attemptToAddToReg', `${params.formId};${attrsStringForCookie}`, {
						path: '/',
					});
					var form = $(`#${params.formId}`);
					var baseURL = '/webapp/wcs/stores/servlet/ItemRegistryAdd';
					var URL = 'https://' + window.location.host + baseURL;
					form.append('<input type="hidden" name="finalView" value="LogonForm" />');
					var productId = form.find(' :input[name=productId]').val();
					
					form.find(' :input[name=URL]').val(`ItemRegistryAdd?${form.serialize()}`);
					form.find(' :input[name=rURL]').val(`ItemRegistryAdd?${form.serialize()}`);
					form.prop('action', URL);
					form.submit();
				} else if (html.search('Error Adding Item to Your Registry') > 0) {
					$(`#${params.formId}`)
						.parent()
						.prepend(
							'<div id="addedToWishlist-error-alert" class="alert alert-danger alert-dismissible" role="alert"><button class="alert-dismiss" type="button" data-dismiss="alert" id="addedToWishlist-alert-close-btn"><i class="fa fa-times"></i></button>There was an error adding this item to your registry. Please try again later.</div>'
						);
					$('body').removeClass('modal-open');
					$('html').removeClass('html-modal-open');
					$('#FieldTwoForForm').remove();
				} else if (html.search('PickRegistryModal') > 0) {
					$('#dynamicModalContainer').modal({
						backdrop: 'static',
						keyboard: false,
					});
					returnHTML(html, myCallback);
					$('.modal-title').addClass('pickRegistry');
					$('.modal-body').addClass('pickRegistryBody');
					$('.modal-title').html('Pick a Registry.');
					$('.close').show();
					
					$('.add-to-modal-title').html(productTitleForAddToModal);
					$('#FieldTwoForForm').remove();
					$('.add-to-modal-image').attr('src', imageForAddToModal);
					if ($('.quickview-image').length > 0) {
						if ($('.qv-modal').length > 0) $('.qv-modal').remove();
						if ($('body').hasClass('modal-special')) $('body').removeClass('modal-special');
					}
				} 
				else {
					let locationURL = `https://${window.location.host}/webapp/wcs/stores/servlet/`;
					if (calledFrom != null && calledFrom == 'Wishlist'){
						location.href = `${locationURL}InterestItemDisplay?storeId=301&catalogId=301&langId=-1&mvId=${catEntryId}`;
					}else{
						location.href = `${locationURL}OrderItemDisplay?storeId=301&catalogId=301&langId=-1&mvId=${catEntryId}`;
					}
					
				}
			},
			error: function () {
				console.log("error function")
				let locationURL = `https://${window.location.host}/webapp/wcs/stores/servlet/`;
				var attrsStringForCookie = '';
				$(`#${params.formId}`)
					.find('select')
					.each(function () {
						if (attrsStringForCookie.length > 0) attrsStringForCookie += '|';
						attrsStringForCookie += `${$(this).attr('id')}:${$(this).val()}`;
					});
				Cookies.set('attemptToAddToReg', `${params.formId};${attrsStringForCookie}`, {
					path: '/',
				});
				var form = $(`#${params.formId}`);
				form.append('<input type="hidden" name="finalView" value="LogonForm" />');
				form.find(' :input[name=URL]').val(`OrderItemDisplay?storeId=301&catalogId=301&langId=-1`);
				form.find(' :input[name=rURL]').val(`OrderItemDisplay?storeId=301&catalogId=301&langId=-1`);
				location.href = `${locationURL}LogonForm?${form.serialize()}`;
			},
		});
	}
};

export { 
	allDevicesColorRegistryButton, 
	registryReturnCodeMessages, 
	ajaxAddToRegistry,
	ajaxMoveToRegistry, 
	allDevicesBindEventTypeToRURL 
};
